import apiClient from './Request'
import { baseUrls } from './../const'

export default {
  GetReportType() {
    return apiClient.get(baseUrls['reportBaseUrl'] + '/report/GetReportType')
  },
  GetUserGroups(filterName) {
    return apiClient.get(
      baseUrls['reportBaseUrl'] +
        '/report/GetUserGroups?filterName=' +
        filterName
    )
  },
  Download(fromDate, toDate, reportId, groups) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['reportBaseUrl'] +
        '/report/Download?fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&reportId=' +
        reportId,
      data: groups,
      responseType: 'blob',
      timeout: 24 * 3600 * 1000
    })
  },
  GetPodDiagnostics(macFilter) {
    return apiClient.get(
      baseUrls['reportBaseUrl'] +
        '/board/GetPodDiagnostics?macFilter=' +
        macFilter
    )
  },
  SendEmail(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['reportBaseUrl'] + '/email/SendEmail',
      data: data
    })
  }
}
